import { DateTime } from 'luxon'
import { z } from 'zod'

export const dateTimeSchema = z.custom<DateTime>((data) => data instanceof DateTime)
